import * as CookieConsent from "vanilla-cookieconsent";
import Tracking from "../utils/Tracking";
import Device from "../utils/Device";
import { I18n } from "./../services/I18n";
// Config docs: https://cookieconsent.orestbida.com/reference/configuration-reference.html
function getCookieConfig() {
    const settings_link = ` <button type="button" data-cc="c-settings" class="cc-link">${I18n.t("cookie_consent.consent_modal.settings")}</button>`;
    const privacy_policy_link = `<a href="/privacy-policy">${I18n.t("cookie_consent.consent_modal.privacy_policy")}</a>`;
    return {
        /**
         * Bump `revision` if you want to show consent widget again for all users.
         * Do it also in E2E tests in `/tests/lib/page-includes/accept-cookies.js`.
         * Android mobile apps also need that change in method `initCookieConsent()` in `/pendolino/client/js/client.js`
         */
        revision: 1,
        autoShow: true,
        hideFromBots: true,
        manageScriptTags: true,
        // disablePageInteraction: false,
        cookie: {
            sameSite: "None",
        },
        guiOptions: {
            consentModal: {
                equalWeightButtons: true,
                flipButtons: false,
            },
            preferencesModal: {
                equalWeightButtons: true,
                flipButtons: false,
            },
        },
        // onChange: ({cookie, changedCategories, changedPreferences}) => {}
        onConsent: ({ cookie }) => {
            const tracking = Tracking.init();
            const layer = window;
            const categories = cookie.categories;
            layer.gtag("consent", "update", {
                ad_storage: categories.includes("marketing") ? "granted" : "denied",
                ad_user_data: categories.includes("marketing") ? "granted" : "denied",
                ad_personalization: categories.includes("marketing")
                    ? "granted"
                    : "denied",
                analytics_storage: categories.includes("analytics")
                    ? "granted"
                    : "denied",
            });
            // HACK To make GTM accept the new consents
            layer.dataLayer.push({ event: "gtm.init_consent" });
            Skubacz.tracking({
                tag: "ConsentsAccepted",
                initialPageView: true,
                cookieLevels: categories,
            });
        },
        categories: {
            // necessary: {
            //   enabled: true,
            //   readOnly: true
            // },
            functionality: {
                enabled: true,
                readOnly: true,
                // autoClear: {} Clear cookies defined here when the user rejects the cookie category.
            },
            analytics: {
                enabled: false,
                readOnly: false,
            },
            marketing: {
                enabled: false,
                readOnly: false,
            },
        },
        language: {
            default: "en",
            translations: {
                en: {
                    consentModal: {
                        title: I18n.t("cookie_consent.consent_modal.title"),
                        description: I18n.t("cookie_consent.consent_modal.description", {
                            settings_link,
                            privacy_policy_link,
                        }),
                        acceptAllBtn: I18n.t("cookie_consent.consent_modal.accept_all"),
                        acceptNecessaryBtn: I18n.t("cookie_consent.consent_modal.accept_necessary"),
                        showPreferencesBtn: I18n.t("cookie_consent.consent_modal.settings"),
                    },
                    preferencesModal: {
                        title: I18n.t("cookie_consent.settings_modal.title"),
                        acceptAllBtn: I18n.t("cookie_consent.settings_modal.accept_all_btn"),
                        acceptNecessaryBtn: I18n.t("cookie_consent.consent_modal.accept_necessary"),
                        savePreferencesBtn: I18n.t("cookie_consent.settings_modal.save_settings_btn"),
                        closeIconLabel: "Close modal",
                        sections: [
                            {
                                title: I18n.t("cookie_consent.privacy.title"),
                                description: I18n.t("cookie_consent.privacy.description"),
                            },
                            {
                                title: I18n.t("cookie_consent.functional_cookies.title"),
                                description: I18n.t("cookie_consent.functional_cookies.description"),
                                linkedCategory: "functionality",
                                cookieTable: {
                                    headers: {
                                        name: I18n.t("cookie_consent.cookie_table.headers.name"),
                                        source: I18n.t("cookie_consent.cookie_table.headers.source"),
                                        description: I18n.t("cookie_consent.cookie_table.headers.description"),
                                    },
                                    body: [
                                        {
                                            name: "cc_cookie",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.consent"),
                                        },
                                        {
                                            name: "currentRestaurant",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.current_restaurant"),
                                        },
                                        {
                                            name: "cart",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.cart"),
                                        },
                                        {
                                            name: "locationCache",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.location_cache"),
                                        },
                                        {
                                            name: "user",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.user"),
                                        },
                                        {
                                            name: "deliveryMethod",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.delivery_method"),
                                        },
                                        {
                                            name: "deliveryAddress",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.delivery_address"),
                                        },
                                    ],
                                },
                            },
                            {
                                title: I18n.t("cookie_consent.analytics_cookies.title"),
                                description: I18n.t("cookie_consent.analytics_cookies.description"),
                                linkedCategory: "analytics",
                                cookieTable: {
                                    headers: {
                                        name: I18n.t("cookie_consent.cookie_table.headers.name"),
                                        source: I18n.t("cookie_consent.cookie_table.headers.source"),
                                        description: I18n.t("cookie_consent.cookie_table.headers.description"),
                                    },
                                    body: [
                                        {
                                            name: "^_ga",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_analytics"),
                                        },
                                        {
                                            name: "^_gid",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_analytics"),
                                        },
                                        {
                                            name: "^_utm",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_analytics"),
                                        },
                                        {
                                            name: "^ahoy",
                                            source: "restaumatic.com",
                                            description: I18n.t("cookie_consent.cookie_table.ahoy"),
                                        },
                                    ],
                                },
                            },
                            {
                                title: I18n.t("cookie_consent.marketing_cookies.title"),
                                description: I18n.t("cookie_consent.marketing_cookies.description"),
                                linkedCategory: "marketing",
                                // Google cookie list: https://business.safety.google/adscookies/
                                cookieTable: {
                                    headers: {
                                        name: I18n.t("cookie_consent.cookie_table.headers.name"),
                                        source: I18n.t("cookie_consent.cookie_table.headers.source"),
                                        description: I18n.t("cookie_consent.cookie_table.headers.description"),
                                    },
                                    body: [
                                        {
                                            name: "^_fbp",
                                            source: "facebook.com",
                                            description: I18n.t("cookie_consent.cookie_table.facebook_pixel"),
                                        },
                                        {
                                            name: "^_gcl",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_ads"),
                                        },
                                        {
                                            name: "^_gac",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_ads"),
                                        },
                                        {
                                            name: "^ad_",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_ads"),
                                        },
                                        {
                                            name: "CONVERSION",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_ads"),
                                        },
                                        {
                                            name: "^_opt",
                                            source: "google.com",
                                            description: I18n.t("cookie_consent.cookie_table.google_optimize"),
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                },
            },
        },
    };
}
function initCookieConsent() {
    if (Device.isMobileApp()) {
        // Android mobile apps don't require cookie acceptance, because it is done when installing the app
        // IOS apps don't import this file
        document.cookie =
            'cc_cookie={"categories":["functionality","analytics","marketing"],"revision":1,"data":null};path=/;samesite=None;Secure';
    }
    CookieConsent.run(getCookieConfig());
}
/**
 * Cookie consent component.
 */
export default {
    init: initCookieConsent,
};
